import React, { useEffect } from "react";
import { appPages } from "../../common/links";

const ContentWrapper = function({children, pageId}){
    return (
        <div id="content">
            <div className="content_caption">
                {
                    appPages.filter(value => value.state===pageId)[0].text
                }
            </div>
            <div className="pageContent">
                {children}
            </div>
        </div>
    );
}
export default ContentWrapper;